export interface NestedDatasetColumnOption {
  dataset: string;
  field: string;
  label: string;
  value: string;
}

const DATASET_FIELD_SEPARATOR = '\u001f';

/** One grouped column list across every dataset selected for the component. */
export function nestedDatasetColumnOptions(
  datasets: string[],
  columnsForDataset: (dataset: string) => string[],
): NestedDatasetColumnOption[] {
  return Array.from(new Set(datasets.filter(Boolean))).flatMap((dataset) =>
    columnsForDataset(dataset).map((field) => ({
      dataset,
      field,
      label: field,
      value: nestedDatasetColumnValue(dataset, field),
    })),
  );
}

export function nestedDatasetColumnValue(dataset: string, field: string): string {
  return dataset && field ? `${dataset}${DATASET_FIELD_SEPARATOR}${field}` : '';
}

export function parseNestedDatasetColumnValue(value: string): { dataset: string; field: string } | null {
  const separator = value.indexOf(DATASET_FIELD_SEPARATOR);
  if (separator < 1 || separator === value.length - 1) return null;
  return { dataset: value.slice(0, separator), field: value.slice(separator + 1) };
}
